<template>
    <v-dialog v-model="isVisible" persistent max-width="600px">
        <v-card v-if="!isUploading">
            <v-card-title>
                <span class="headline">Import Demo Data</span>
                <h5 style="margin-top: 10px">{{ clinic ? clinic.company : '' }}</h5>
                <h6 style="margin-top: -10px">{{ clinic && clinic.practice_ID ? `(${clinic.practice_ID})` : '' }}</h6>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-file-input v-model="field.file" :label="`File (${clinic && clinic.practice_ID? 'CSV': 'XLST'}) *`" required
                                :error="!field.file && isFormDirty" />
                        </v-col>
                    </v-row>
                </v-container>

                <small>* indicates required field</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="secondary" text @click="close">
                    Cancel
                </v-btn>
                <v-btn color="primary" text @click="upload">
                    Import
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="isUploading">
            <v-card-title>
                <span class="headline">Uploading</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <div class="progressOuterWrapper">
                                <div class="progressOuterWrapper">
                                    <div class="progressWrapper">
                                        <div class="progress" :style="{ width: `${uploadProgress}%` }"></div>
                                    </div>
                                </div>
                                <div class="actions">
                                    <button class="cancelBtn" @click="_cancelUpload">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snackbar">
            {{ notification }}

            <template v-slot:action="{ attrs }">
                <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>
<script>
  /* eslint-disable */
import axios from "axios";
import downloadCsv from "download-csv";
import Api from "../../../shared-module/api";

const initialfields = {
    file: null
};

export default {
    name: "ClinicDemoDataUploader",
    props: {
        clinic: {
            type: Object,
            default: null
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        user: null,
        field: Object.assign({}, initialfields),
        isFormDirty: false,
        snackbar: false,
        notification: "Unknown",
        uploadProgress: 20,
        isUploading: false,
        cancelRef: () => { }
    }),

    watch: {
        isVisible(val) {
            if (!val) {
                this.close();
            }
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            this.isUploading = false;
        },

        close() {
            this.$emit("on-close");
            this.field = Object.assign({}, initialfields);
            this.isFormDirty = false;
            this.snackbar = false;
        },

        isFormValid() {
            let isValid = true;
            if (!this.field.file) {
                isValid = false;
            }
            return isValid;
        },

        _checkIfValidFile() {
            let isValidFile = false;
            let validFileExtension = 'xlst';
            if (this.clinic && this.clinic.practice_ID) {
                validFileExtension = 'csv';
            }
            if (
                this.field.file &&
                this.field.file.name &&
                this.field.file.name.toLowerCase().indexOf(validFileExtension) > -1
            ) {
                isValidFile = true;
            }
            return isValidFile;
        },

        async upload() {
            const isValidFile = this._checkIfValidFile();
            if (!isValidFile) {
                this.notification = "Please select a valid file";
                this.snackbar = true;
                return;
            }
            // this.$emit("on-start");
            const formData = new FormData();

            formData.append("File", this.field.file);
            formData.append("POSPracticeID", this.clinic.practice_ID);
            formData.append("practiceID", this.clinic.practice_ID);


            try {
                this.isUploading = true;
                this.uploadProgress = 0;
                const cancelToken = axios.CancelToken;
                this.cancelRef = cancelToken.source();
                const { CancelToken } = axios;
                if (this.clinic && this.clinic.practice_ID) {
                    await Api.clinic.private.importDemoDataForPractice({
                        additionals: {
                            onUploadProgress: progressEvent => {
                                console.log(progressEvent.loaded);
                                const progress = (progressEvent.loaded / progressEvent.total) * 100;
                                this.uploadProgress = Math.round(progress);
                            },
                            cancelToken: new CancelToken(c => {
                                // An executor function receives a cancel function as a parameter
                                this.cancelRef = c;
                            })
                        },
                        payload: formData,
                    })
                } else {
                    await Api.clinic.private.importDemoData(formData, {
                        onUploadProgress: progressEvent => {
                            console.log(progressEvent.loaded);
                            const progress = (progressEvent.loaded / progressEvent.total) * 100;
                            this.uploadProgress = Math.round(progress);
                        },
                        cancelToken: new CancelToken(c => {
                            // An executor function receives a cancel function as a parameter
                            this.cancelRef = c;
                        })
                    });
                }
                this.$emit("on-success");
                this.close();
            } catch (error) {
                console.log("error :>> ", error);
                this.$emit("on-error", error);
            }
            this.uploadProgress = 0;
            this.isUploading = false;
        },
        _cancelUpload() {
            this.uploadProgress = 0;
            this.isUploading = false;
            this.cancelRef();
        },
        _downloadCsv() {
            downloadCsv(
                [
                    {
                        FirstName: "",
                        LastName: "",
                        CellPhone: "",
                        Email: ""
                    }
                ],
                {},
                "pos_template"
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.sampleCsvDownloadBtn {
    background: black;
    border-radius: 4px;
    padding: 4px 25px;
    color: white;
    box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.2);
    margin-bottom: 2rem;
    font-weight: 600;

    &:hover {
        box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.2);
        background: black;
    }
}

.v-dialog {
    overflow-y: hidden;
}

.progressOuterWrapper {
    .progressOuterWrapper {
        height: 30px;
    }
}

.progressWrapper {
    margin-top: 1.5rem;
    margin-bottom: -4rem;
    height: 10px !important;
    background: rgb(221, 221, 221);
    border-radius: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .progress {
        border-radius: 10px;
        background-color: #00a75c;
        height: 10px !important;
        width: 0%;
    }
}
</style>
